export const rows = [
  {
    section: "Day",
    data: [
      ["%a", "Abbreviated weekday name.", "Sun, Mon, …"],
      ["%A", "Full weekday name.", "Sunday, Monday, …"],
      ["%w", "Weekday as a decimal number.", "0, 1, …, 6"],
      ["%d", "Day of the month as a zero-padded decimal.", "01, 02, …, 31"],
      ["%-d", "Day of the month as a decimal number.", "1, 2, …, 30"],
    ],
  },
  {
    section: "Month",
    data: [
      ["%b", "Abbreviated month name.", "Jan, Feb, …, Dec"],
      ["%B", "Full month name.", "January, February, …"],
      ["%m", "Month as a zero-padded decimal number.", "01, 02, …, 12"],
      ["%-m", "Month as a decimal number.", "1, 2, …, 12"],
    ],
  },
  {
    section: "Year",
    data: [
      ["%y", "Year without century as a zero-padded decimal number.", "00, 01, …, 99"],
      ["%-y", "Year without century as a decimal number.", "0, 1, …, 99"],
      ["%Y", "Year with century as a decimal number.", "2013, 2019 etc."],
    ],
  },
  {
    section: "Hour",
    data: [
      ["%H", "Hour (24-hour clock) as a zero-padded decimal number.", "00, 01, …, 23"],
      ["%-H", "Hour (24-hour clock) as a decimal number.", "0, 1, …, 23"],
      ["%I", "Hour (12-hour clock) as a zero-padded decimal number.", "01, 02, …, 12"],
      ["%-I", "Hour (12-hour clock) as a decimal number.", "1, 2, … 12"],
      ["%p", "Locale’s AM or PM.", "AM, PM"],
    ],
  },
  {
    section: "Minute",
    data: [
      ["%M", "Minute as a zero-padded decimal number.", "00, 01, …, 59"],
      ["%-M", "Minute as a decimal number.", "0, 1, …, 59"],
    ],
  },
  {
    section: "Seconds",
    data: [
      ["%S", "Second as a zero-padded decimal number.", "00, 01, …, 59"],
      ["%-S", "Second as a decimal number.", "0, 1, …, 59"],
      ["%g", "Millisecond as a decimal number, zero-padded on the left.", "000 - 999"],
      ["%f", "Microsecond as a decimal number, zero-padded on the left.", "000000 - 999999"],
    ],
  },
  {
    section: "Others",
    data: [
      ["%z", "Time offset from UTC in the form ±HH:MM, ±HHMM, or ±HH.", "-0700"],
      ["%Z", "Time zone name.", "Europe/Amsterdam"],
      ["%j", "Day of the year as a zero-padded decimal number.", "001, 002, …, 366"],
      ["%-j", "Day of the year as a decimal number.", "1, 2, …, 366"],
      ["%U", "Week number of the year (Sunday as the first day of the week).", "00, 01, …, 53"],
      ["%W", "Week number of the year (Monday as the first day of the week).", "00, 01, …, 53"],
      ["%c", "ISO date and time representation", "1992-03-02 10:30:20"],
      ["%x", "ISO date representation.", "1992-03-02"],
      ["%X", "ISO time representation", "10:30:20"],
      ["%%", "A literal ‘%’ character.", "%"],
    ],
  },
];